import { ART_PALETTE } from '../art-palette.js';

export const blankPixels = (fill = 0) => Array.from({ length: 16 }, () => Array(16).fill(fill));

/**
 * Integer hash in [0,1), for motif placement jitter. Modulo formulas like
 * `(x * a + y * b) % m` band diagonally and are visible at 1x (art rules §0.6).
 */
export function hash(x, y) {
  let value = Math.imul(x, 0x1f123bb5) ^ Math.imul(y, 0x5f356495);
  value ^= value >>> 15;
  value = Math.imul(value, 0x2c1b3c6d);
  value ^= value >>> 12;
  return (value >>> 0) / 0x100000000;
}

export function rotateClockwise(pixels) {
  return Array.from({ length: 16 }, (_, y) =>
    Array.from({ length: 16 }, (_, x) => pixels[15 - x][y]));
}

export function plainTile({ key, name, channel, section, component, pixels, collision = {}, ...metadata }) {
  return {
    key, name, channel, mode: 'plain', paletteSection: section, palette: ART_PALETTE,
    collision, components: { [component]: { 0: pixels } }, ...metadata,
  };
}

export function footprintTile({ key, name, channel, section, component, cells, width, height,
  collision = {}, ...metadata }) {
  if (cells.length !== width * height) throw new Error(`${key}: footprint cell count does not match ${width}x${height}`);
  return {
    key, name, channel, mode: 'footprint', footprint: { width, height },
    paletteSection: section, palette: ART_PALETTE, collision,
    components: { [component]: Object.fromEntries(cells.map((pixels, index) => [index, pixels])) },
    ...metadata,
  };
}

export function randomVariantTile({ key, name, channel, section, component, variants, animationFrames = null,
  frameDurationMs = 480, interactionFrameDurationMs = 70, collision = {}, ...metadata }) {
  const tile = {
    key, name, channel, mode: 'random', randomVariantCount: variants.length,
    paletteSection: section, palette: ART_PALETTE, collision,
    components: { [component]: Object.fromEntries(variants.map((pixels, index) => [index, pixels])) },
    ...metadata,
  };
  if (animationFrames) tile.animation = {
    component, frameDurationMs, interactionFrameDurationMs, interactionDurationMs: 520,
    variantFrames: animationFrames.map((frame) =>
      Object.fromEntries(frame.map((pixels, index) => [index, pixels]))),
  };
  return tile;
}

export function floraPixels(draw) {
  const pixels = blankPixels();
  const put = (x, y, color) => {
    if (x >= 0 && x < 16 && y >= 0 && y < 16) pixels[y][x] = color;
  };
  const rect = (x, y, width, height, color) => {
    for (let py = y; py < y + height; py++) for (let px = x; px < x + width; px++) put(px, py, color);
  };
  draw({ pixels, put, rect });
  return pixels;
}
